import { useEffect, useState } from 'react';
import { registrationStatusResponseSchema } from '@unit/shared';
import { publicGet } from '../../lib/api.js';

/**
 * Whether the public self-registration form is switched on (story 33).
 * Asked without a token — the sign-in screen shows the link only when the
 * form would actually accept something. `null` while unknown.
 */
export function useRegistrationOpen(): boolean | null {
  const [open, setOpen] = useState<boolean | null>(null);
  useEffect(() => {
    let alive = true;
    publicGet('/public/registration', registrationStatusResponseSchema)
      .then((r) => alive && setOpen(r.enabled))
      .catch(() => alive && setOpen(false));
    return () => {
      alive = false;
    };
  }, []);
  return open;
}
